import { TransactionTypes } from '../../types/RewardsActivityCard'

export const getTransactionColor = (
  transactionType: TransactionTypes,
): string => {
  switch (transactionType) {
    case TransactionTypes.TokensReceived:
    case TransactionTypes.ChestReceived:
      return 'venasaur.500'
    case TransactionTypes.TokensRemoved:
      return 'kirby.500'
    default:
      return ''
  }
}
